module.exports = __webpack_public_path__ + "static/media/reply-sub.0c1dd16a.gif";